<template>
  <div class="select-data">
    <div class="select-data-header">
      <x-input-search @search="handleSearch"></x-input-search>
    </div>
    <div class="select-data-body">
      <cube-scroll
        ref="scroll"
        :data="listData"
        :options="cubeScrollOptions"
        @pulling-down="onPullingDown"
        @pulling-up="onPullingUp"
      >
        <template v-for="rowData in listData">
          <select-data-option
            :key="rowData.id"
            :rowData="rowData"
            :colConfigs="config.colConfigs"
            @select="handleSelect"
          ></select-data-option>
        </template>
      </cube-scroll>
    </div>
    <div class="select-data-footer">
      <div class="footer--info text-ellipsis">
        <span class="footer--help">{{ help }}</span>
      </div>
      <div class="footer--btn">
        <cube-button primary @click="handleConfirm">
          确定
        </cube-button>
      </div>
    </div>
  </div>
</template>

<script>
import SelectDataOption from './select-data-option/select-data-option'
import {
  SET_COMP_VALUE
} from '@/store/comp-router.store.js'
import {
  mapState,
  mapMutations
} from 'vuex'
import apis from '@/api'
import pageMixin from '@/mixin/page.mixin.js'

export default {
  components: {
    SelectDataOption
  },
  mixins: [pageMixin],
  data() {
    return {
      compPayloadKey: this.$route.query.key,
      selectType: 'SINGLE',
      selectedArray: [],
      listData: [],
      cubeScrollOptions: {
        // preventDefault: false,
        pullDownRefresh: {
          txt: '刷新成功'
        },
        pullUpLoad: {
          txt: {
            more: '上滑加载更多',
            noMore: '没有更多数据了'
          }
        },
        scrollbar: false
      },
      pageInfo: {
        page: 1,
        pageSize: 10,
        keyWord: ''
      }
    }
  },
  computed: {
    ...mapState({
      compPayload: state => state.compRouterModule.compPayload
    }),

    config() {
      return this.compPayload[this.compPayloadKey].widgetConfig
    },
    formData() {
      return this.compPayload[this.compPayloadKey].formData
    },
    formId() {
      return this.compPayload[this.compPayloadKey].formId
    },

    help() {
      if (this.selectType === 'SINGLE') {
        if (this.selectedArray[0]) {
          if (this.selectedArray[0].label === undefined) {
            return `单选，已选择「」`
          } else if (typeof (this.selectedArray[0].label) === 'object') {
            // 如果是人员选择 则显示名字
            return `单选，已选择「${this.selectedArray[0] ? this.selectedArray[0].label[0].username : ''}」`
          } else {
            return `单选，已选择「${this.selectedArray[0] ? this.selectedArray[0].label : ''}」`
          }
        } else {
          return `单选，已选择「」`
        }
      } else {
        return `多选，已选择${this.selectedArray.length}条记录 ${this.selectedArray.length}/30`
      }
    }
  },
  watch: {
    'selectedArray': {
      handler(newVal, oldVal) {
        this.updateListData(newVal)
      }
    }
  },
  created() {
    if (this.compPayload[this.compPayloadKey].value && this.compPayload[this.compPayloadKey].value.id) {
      let copy = this.$lodash.cloneDeep(this.compPayload[this.compPayloadKey].value)
      this.selectedArray = [{
        label: copy.name,
        value: copy.id
      }]
    }
    this.queryData().then(resp => {
      this.listData = resp.data
    })
  },
  methods: {
    ...mapMutations('compRouterModule', {
      setCompValue: SET_COMP_VALUE
    }),
    handleSearch(value) {
      console.log(value)
      this.pageInfo.keyWord = value
      this.pageInfo.page = 1
      this.queryData().then(resp => {
        this.listData = resp.data
      })
    },
    onPullingDown() {
      this.pageInfo.page = 1
      this.queryData().then(resp => {
        this.listData = resp.data
      })
    },
    onPullingUp() {
      this.pageInfo.page++
      this.queryData().then(resp => {
        this.listData.push(...resp.data)
        this.$nextTick(() => {
          this.$refs.scroll.forceUpdate()
        })
      }).catch(() => {
        this.$refs.scroll.forceUpdate()
      })
    },
    queryData() {
      const request = {
        ...apis.COMPONENT.QUERY_LIST_BUSINESS_DATA,
        params: {
          ...this.pageInfo,
          formId: this.$route.query.formId || this.formId, // 分享表单取不到formId，这边需要传进一个formId
          componentId: this.config.uuid,
          data: this.formData
        }
      }
      return new Promise((resolve, reject) => {
        this.$request(request).asyncThen((resp) => {
          resolve({
            data: resp.data.map((item) => {
              return {
                value: item.id,
                label: item[this.config.dataSelector.otherComponent],
                extra: item,
                checked: this.selectedArray.findIndex(_item => _item.value === (item.value || item.id)) !== -1
              }
            }),
            total: resp.total
          })
        }, (err) => {
          reject(err)
        }).asyncErrorCatch(err => {
          reject(err)
        })
      })
    },
    handleConfirm() {
      this.setCompValue({
        key: this.compPayloadKey,
        value:
        this.selectedArray && this.selectedArray.length > 0
          ? {
            id: this.selectedArray[0].value,
            name: this.selectedArray[0].extra.lovDisplayValue
          } : {}
      })
      this.$emitWithEventBus('mappingAssignment', {
        key: this.compPayloadKey,
        value: this.$lodash.cloneDeep(this.selectedArray)
      }, {
        scope: 'APP',
        customKey: this.compPayloadKey
      })
      this.$router.go(-1)
    },
    handleSelect(rowData) {
      if (rowData.checked) {
        if (this.selectType === 'SINGLE') {
          let o = this.selectedArray.pop()
          if (o) o.checked = false
        }
        this.selectedArray.push(rowData)
      } else {
        const index = this.selectedArray.findIndex(item => item.value === rowData.value)
        if (index !== -1) {
          this.selectedArray.splice(index, 1)
        }
      }
    },
    updateListData(selectedArray) {
      this.listData.forEach(item => {
        const index = selectedArray.findIndex(_item => _item.value === item.value)
        item.checked = index !== -1
      })
    }
  }
}
</script>

<style lang="scss">
.select-data {
  background-color: $--app-body-bgColor;
  .select-data-body {
    height: calc(100vh - 7.42rem);
    overflow: hidden;
  }
  .select-data-footer {
    position: fixed;
    bottom: 0;
    width: 100vw;
    display: flex;
    align-items: center;
    height: 3.71rem;
    padding: 0 1.14rem;
    box-sizing: border-box;
    background-color: $--app-box-bgColor;
    .footer--info {
      flex: 1;
      .footer--help {
        color: $--app-notice-font-color;
      }
    }
    .footer--btn {
      flex: 0 0 4.64rem;
    }
  }
}
</style>
